angular.module('bmsApp.merrymaids').factory('MMEnquiryCleanTypeSvc', function (CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/mmEnquiryCleanType/options', params);
		}
	}

});
